/* src/app/warehousing/pages/stock-transfer/stock-transfer.component.scss */
/*# sourceMappingURL=stock-transfer.component.css.map */
